import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Community from './index';
import MobileCommunity from './MobileCommunity';

const ResponsiveCommunity = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileCommunity />}
      desktop={<Community />}
    />
  );
};

export default ResponsiveCommunity;